var map = {
	"./App": 32591,
	"./App.tsx": 32591,
	"./BookmakerOptions": 25501,
	"./BookmakerOptions.tsx": 25501,
	"./CallToAction": 40857,
	"./CallToAction.tsx": 40857,
	"./Carousel": 69686,
	"./Carousel.tsx": 69686,
	"./DebugOverlay": 32179,
	"./DebugOverlay.tsx": 32179,
	"./FocusMatch": 63383,
	"./FocusMatch.tsx": 63383,
	"./Layouts": 49797,
	"./Layouts.ts": 49797,
	"./LiveScore": 78310,
	"./LiveScore.tsx": 78310,
	"./LiveStatisticBar": 40179,
	"./LiveStatisticBar.tsx": 40179,
	"./MatchList": 22329,
	"./MatchList.tsx": 22329,
	"./MatchListOdds": 70415,
	"./MatchListOdds.tsx": 70415,
	"./MobileSuiteHeader": 48943,
	"./MobileSuiteHeader.tsx": 48943,
	"./PauseResume": 59545,
	"./PauseResume.tsx": 59545,
	"./PlayerAndOdds": 74342,
	"./PlayerAndOdds.tsx": 74342,
	"./PlayerNames": 71659,
	"./PlayerNames.tsx": 71659,
	"./PlayerPoints": 2058,
	"./PlayerPoints.tsx": 2058,
	"./PlayerProfiles": 41273,
	"./PlayerProfiles.tsx": 41273,
	"./QuickBet": 97230,
	"./QuickBet.tsx": 97230,
	"./Root": 25068,
	"./Root.tsx": 25068,
	"./StatsControls": 11749,
	"./StatsControls.tsx": 11749,
	"./StatsForms": 91246,
	"./StatsForms.tsx": 91246,
	"./StatsHeadToHead": 19160,
	"./StatsHeadToHead.tsx": 19160,
	"./StatsName": 43266,
	"./StatsName.tsx": 43266,
	"./StatsOverall": 22996,
	"./StatsOverall.tsx": 22996,
	"./StatsRanking": 65709,
	"./StatsRanking.tsx": 65709,
	"./Swiper": 53872,
	"./Swiper.tsx": 53872,
	"./Translation": 5981,
	"./Translation.ts": 5981,
	"./VideoArea": 91444,
	"./VideoArea.tsx": 91444,
	"./VideoOptions": 46825,
	"./VideoOptions.tsx": 46825,
	"./VideoOverlay": 80871,
	"./VideoOverlay.tsx": 80871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27653;